// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-notes .name {
  width: 15%;
}
.display-notes .date {
  width: 15%;
}
.display-notes .note {
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/components/display-notes/display-notes.component.scss"],"names":[],"mappings":"AAEI;EAAQ,UAAA;AAAZ;AACI;EAAO,UAAA;AAEX;AADI;EAAO,UAAA;AAIX","sourcesContent":["// Invoice Notes\n.display-notes{\n    .name { width: 15%;}\n    .date {width: 15%;}\n    .note {width: 70% ;}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
